import Vue from 'vue';
// import * as Sentry from "@sentry/vue";
// import { Integrations } from "@sentry/tracing";
import ElementUI from 'element-ui';
import './elementStyles/theme/index.css';
import {
    Input,
    Checkbox,
    Button,
    Message,
    Layout,
    Header,
    Content,
    Sider,
    Menu,
    Submenu,
    MenuItem,
    Icon,
    Tabs,
    TabPane,
    Card,
    Page,
    Form,
    FormItem,
    Select,
    Option,
    Row,
    Col,
    Spin,
    DatePicker,
    Upload,
    Modal,
    Progress,
    RadioGroup,
    Radio,
    // V2
    CheckboxGroup,
    Table,
    Tree,
    OptionGroup,
    Switch,
    Tooltip,
    CellGroup,
    Cell,
    Dropdown,
    DropdownMenu,
    DropdownItem,
    Divider,
    Poptip,
    Cascader,
    InputNumber,
    TimePicker,
    Rate,
    AnchorLink,
    Anchor,
    AutoComplete,
    Tag,
    Scroll,
    Badge,
    Drawer,
    Alert,
    locale
} from 'iview';
import lang from 'iview/dist/locale/zh-CN';

import caringButton from './views/common/caring-button.vue';
import 'iview/dist/styles/iview.css';
import App from './app.vue';
import router from './route/router';
import store from './store';
import Utils from './libs/util';
import './utils/preventReClick'; // 防多次点击，重复提交
import './permission';
import hevueImgPreview from 'hevue-img-preview';
locale(lang);
Vue.use(ElementUI);
Vue.use(hevueImgPreview)
Vue.component('caring-button', caringButton);
Vue.component('Input', Input);
Vue.component('Checkbox', Checkbox);
Vue.component('Button', Button);
Vue.component('Layout', Layout);
Vue.component('Header', Header);
Vue.component('Content', Content);
Vue.component('Sider', Sider);
Vue.component('Menu', Menu);
Vue.component('Submenu', Submenu);
Vue.component('MenuItem', MenuItem);
Vue.component('Icon', Icon);
Vue.component('Tabs', Tabs);
Vue.component('TabPane', TabPane);
Vue.component('Card', Card);
Vue.component('Page', Page);
Vue.component('Form', Form);
Vue.component('FormItem', FormItem);
Vue.component('Select', Select);
Vue.component('Option', Option);
Vue.component('Row', Row);
Vue.component('Col', Col);
Vue.component('Spin', Spin);
Vue.component('DatePicker', DatePicker);
Vue.component('Upload', Upload);
Vue.component('Modal', Modal);
Vue.component('Progress', Progress);
Vue.component('RadioGroup', RadioGroup);
Vue.component('Radio', Radio);
// V2
Vue.component('CheckboxGroup', CheckboxGroup);
Vue.component('Table', Table);
Vue.component('Tree', Tree);
Vue.component('OptionGroup', OptionGroup);
Vue.component('i-switch', Switch);
Vue.component('Tooltip', Tooltip);
Vue.component('CellGroup', CellGroup);
Vue.component('Cell', Cell);
Vue.component('Dropdown', Dropdown);
Vue.component('DropdownMenu', DropdownMenu);
Vue.component('DropdownItem', DropdownItem);
Vue.component('Divider', Divider);
Vue.component('Poptip', Poptip);
Vue.component('Cascader', Cascader);
Vue.component('InputNumber', InputNumber);
Vue.component('TimePicker', TimePicker);
Vue.component('Rate', Rate);
Vue.component('AnchorLink', AnchorLink);
Vue.component('AutoComplete', AutoComplete);
Vue.component('Tag', Tag);
Vue.component('Anchor', Anchor);
Vue.component('Scroll', Scroll);
Vue.component('Badge', Badge);
Vue.component('Drawer', Drawer);
Vue.component('Alert', Alert);


Vue.prototype.$Message = Message;
Vue.prototype.$Modal = Modal;
Vue.prototype.$utils = Utils;
Vue.config.productionTip = false;
if (process.env.NODE_ENV !== 'development') {
    // Sentry.init({
    //   Vue,
    //   release: 'app@0.0.1',
    //   dsn: "https://be614dc3005d4bc1bae8b0a500e283f8:c09e2fcebbc84fc8ab803319e69d6194@sentry.chinacaring.com/4",
    //   integrations: [
    //     new Integrations.BrowserTracing({
    //       routingInstrumentation: Sentry.vueRouterInstrumentation(router),
    //       tracingOrigins: ["localhost", "my-site-url.com", /^\//],
    //     }),
    //   ],
    //   tracesSampleRate: 1.0,
    // });
}

new Vue({
    router,
    store,
    render: (h) => h(App),
}).$mount('#app');